import { AppointmentType } from 'hooks/useAppointments';

export type TimeSlotAvailability = {
  hour: number;
  minute: number;
};

export type HourAvailability = {
  from: TimeSlotAvailability;
  to: TimeSlotAvailability;
};

export type DayAvailability = {
  days: number[]; //0 - 6, 0 being Sunday
  hours: HourAvailability[];
};

export type SpecialAvailability = {
  year: number | null;
  month: number | null;
  day: number | null;
  hours: HourAvailability[];
};

export type BusinessHours = {
  timezone: string;
  weekly: DayAvailability[];
  specialDays: SpecialAvailability[];
};

export interface departmentInfo {
  name: string;
  url: string;
}
export interface MedicalcareDoctor {
  name: string;
  userId: string;
  department: string;
  departments: string[];
  hospital: string;
  businessHours?: BusinessHours;
  departmentsInfo: departmentInfo[];
}

export interface AppointmentImageAttachment {
  type?: string | null;
  authorName?: string | null;
  title?: string | null;
  titleLink?: string | null;
  text?: string | null;
  imageURL?: string | null;
  thumbURL?: string | null;
  assetURL?: string | null;
  ogScrapeURL?: string | null;
  extraInfo?: any;
}

export type PrescriptionType = 'paper' | 'electronic';

export interface PaymentIntent {
  id: string;
  amount: number;
  paymethod: string;
  extraInfo?: any;
}
export interface IAppointment {
  deviceId?: string;
  doctorName?: string;
  paymentType?: 'insurancePayment' | 'selfPayment';
  timeForSorting?: string;

  id: string;
  patientUserId?: string;
  patientEmail: string;
  doctorUserID?: string;
  doctorEmail: string;
  patientName?: string;
  startedAt?: string;
  endedAt?: string;
  notes: string;
  rtcChannelId: string;
  startedAtCandidates?: string[];
  createdAt?: string;
  amount?: number;
  prescription?: string;
  imageAttachments?: AppointmentImageAttachment[];
  appointmentType?: AppointmentType;
  canceled?: boolean;
  confirmCancel?: boolean;
  confirmPaid?: boolean;
  canceledReason?: string;
  paidAt?: string;
  doctorDepartment?: string;
  doctorHospital?: string;
  isInsurance: boolean | null;
  patientInfo?: PatientInfo;
  patientInfoId?: string;
  verifyKeyCode?: string;
  extraInfo?: any;
}

export enum AppointmentStatus {
  PENDING = 'pending',
  PENDING_EXPIRED = 'pendingExpired',
  CONFIRMED = 'confirmed',
  IN_PROGRESS = 'inProgress',
  CANCELED = 'canceled',
  PAYMENT_COMPLETED = 'paymentCompleted',
  PAYMENT_PENDING = 'paymentPending',
  EXPIRED = 'expired',
}

export type PatientInfo = any;

export type DoctorAvailability = HourAvailability[];

export type PickableTimeSlot = {
  hour: number;
  minute: number;
  display: string;
};

export interface PaymentIntent {
  id: string;
  amount: number;
  paymethod: string;
  extraInfo?: any;
}
export interface IAppointmentPage {
  items: IAppointment[];
}

export interface MedicalcareData {
  numOfUnpaid: number;
}

export interface ChatChannel {
  cid: string;
}
